import React from 'react'
import clsx from 'clsx'
import kebabCase from 'lodash.kebabcase'
import { CustomLink } from '@/components/atoms/CustomLink/CustomLink'
import { RichTextField } from '@/components/organisms/RichTextField/RichTextField'
import { Paragraph } from '@/components/atoms/MarkdownElements/MarkdownElements'
import { FeatureListTypes } from './types'

export function FeatureListSection({ pageContent, instance, ...props }: FeatureListTypes) {
  const { content } = pageContent?.blok || instance || {}
  const { title, description, link, features, title_alignment, bg_image, whos, mobile_list_link } = content || props
  const reversed = title_alignment === 'right'
  // take either features or who is it for
  const listItems = features || whos

  return (
    <div
      className="bg-no-repeat bg-clip-padding bg-110 bg-6 tablet:bg-right tablet:bg-contain"
      style={{ backgroundImage: `url(${bg_image?.image})` }}
      id={kebabCase(title)}
    >
      <section
        className={clsx(
          'flex flex-col tablet:flex-row max-w-screen-desktop tablet:items-start tablet:justify-between mx-auto px-24 laptop:px-90 py-24 tablet:py-64',
          reversed && 'tablet:flex-row-reverse'
        )}
      >
        <div className="flex flex-col tablet:w-1/2 max-w-md netbook:w-5/12 pb-40 tablet:pr-24 tablet:pl-0">
          <h2 className="features-title text-headingM-mobile text-text-dark-900 font-poppins font-bold mb-24 netbook:text-headingM">
            {title}
          </h2>
          <div className="features-description text-bodyM text-text-dark-900 mb-24 tablet:max-w-md tablet:text-bodyL leading-30">
            {typeof description === 'string' ? (
              <Paragraph className="text-bodyM text-text-dark-900 mb-24 tablet:max-w-md tablet:text-bodyL leading-30">
                {description}
              </Paragraph>
            ) : (
              <RichTextField data={description} />
            )}
          </div>
          {link && link.length > 0 && (
            <CustomLink {...link[0]}>
              <div className="flex items-center">
                <p className="text-bodyL font-bold text-primary-500 hover:text-primary-400">{link[0].text}</p>
                <i className="fa fa-long-arrow-right text-primary-500 hover:text-primary-400 ml-8" />
              </div>
            </CustomLink>
          )}
        </div>
        <ul
          className={clsx(
            `features-list tablet:grid px-0 py-16 tablet:pt-0 tablet:w-1/2 netbook:w-7/12`,
            whos?.length ? 'netbook:grid-rows-3 netbook:grid-flow-col' : `tablet:grid-cols-2 netbook:grid-cols-3`
          )}
        >
          {[...listItems].map(({ text }, index) => (
            <li
              key={`${text}`}
              className={clsx(
                'features-list-item w-full text-bodyL font-bold font-poppins text-text-dark-900 leading-relaxed mb-24 break-words px-4 tablet:text-bodyM',
                !reversed && 'tablet:pr-16',
                whos?.length ? 'netbook:text-headingS' : 'netbook:text-bodyL netbook:mb-16',
                whos?.length && index === 2 && 'mb-48 tablet:mb-24',
                index > 5 && 'hidden tablet:block'
              )}
            >
              {text}
            </li>
          ))}
        </ul>
        {mobile_list_link && mobile_list_link[0] && (
          <CustomLink {...mobile_list_link[0]} className="tablet:hidden">
            <div className="flex items-center">
              <p className="text-bodyL font-bold text-primary-500 hover:text-primary-400">{mobile_list_link[0].text}</p>
              <i className="fa fa-long-arrow-right text-primary-500 hover:text-primary-400 ml-8" />
            </div>
          </CustomLink>
        )}
      </section>
    </div>
  )
}
